<!-- starts tertiary buttons section-->
<ng-container>
  <div class="row tertiaty-buttons m-b-xl">
    <ng-container *ngIf="isWebChannel">
      <div
        class="button-box small"
        [ngClass]="
          ((lineDetails?.lineStatus === lineLandingConstants.SUSPENDED &&
            deviceDetailsLineInformation?.isImeiValid) ||
            (lineDetails?.lineStatus === lineLandingConstants.ACTIVE &&
              !deviceDetailsLineInformation?.isImeiValid)) &&
          deviceDetailsLineInformation?.imei
            ? 'col-4'
            : 'col-6'
        "
      >
        <a [routerLink]="['/support-landing']" id="support">
          <span class="center">
            <i class="fa fa-comment"></i>
            {{ contentData?.support }}</span
          >
        </a>
      </div>
    </ng-container>

    <ng-container
      *ngIf="
        (lineDetails?.lineStatus === lineLandingConstants.ACTIVE &&
          deviceDetailsLineInformation?.isImeiValid) ||
        lineDetails?.lineStatus === lineLandingConstants.CANCELLED
      "
    >
      <div
        class="col-6 button-box small"
        tmoUIPermission
        [targetName]="permissionConstants.ADD_IMEI_TO_BLACKLIST"
        [permissionType]="permissionConstants.REP_PERMISSION_TYPE"
      >
        <a
          id="report-lost-stolen"
          href="javascript:void(0);"
          [ngClass]="{ disabled: lineDetails?.lineStatus === lineLandingConstants.CANCELLED }"
          (click)="navigateToReport()"
        >
          <span class="center">
            <i class="fa fa-exclamation-triangle"></i>
            {{ contentData?.reportLostOrStolen }}</span
          >
        </a>
      </div>
    </ng-container>
    <ng-container
      *ngIf="
        lineDetails?.lineStatus === lineLandingConstants.ACTIVE &&
        (!deviceDetailsLineInformation?.isImeiValid || !deviceDetailsLineInformation?.imei)
      "
    >
      <div
        class="button-box small"
        [ngClass]="
          lineDetails?.lineStatus === lineLandingConstants.ACTIVE &&
          ((deviceDetailsLineInformation?.imei && !deviceDetailsLineInformation?.isImeiValid) ||
            (deviceDetailsLineInformation?.imei && deviceDetailsLineInformation?.imei === '')) &&
          !isWebChannel
            ? 'col-4'
            : 'col-6'
        "
      >
        <a [routerLink]="['/lost-stolen-device']" id="cta-default-629">
          <span class="center">
            <i class="fa fa-compass"></i>
            {{ contentData?.suspendMyDevice }}
          </span>
        </a>
      </div>
    </ng-container>

    <ng-container
      *ngIf="
        (lineDetails?.lineStatus === lineLandingConstants.ACTIVE ||
          (lineDetails?.lineStatus === lineLandingConstants.SUSPENDED &&
            lineDetails?.lineSubStatus === lineLandingConstants.LOST_STOLEN &&
            !isWebChannel)) &&
        deviceDetailsLineInformation?.imei &&
        !deviceDetailsLineInformation?.isImeiValid
      "
    >
      <div
        class="button-box small"
        [ngClass]="
          (lineDetails?.lineStatus === lineLandingConstants.ACTIVE ||
            (lineDetails?.lineStatus === lineLandingConstants.SUSPENDED &&
              lineDetails?.lineSubStatus === lineLandingConstants.LOST_STOLEN &&
              !isWebChannel)) &&
          deviceDetailsLineInformation?.imei &&
          !deviceDetailsLineInformation?.isImeiValid
            ? 'col-4'
            : 'col-6'
        "
      >
        <a
          [class.disabled]="!isPermissionAvailable"
          id="found-my-phone-section"
          [routerLink]="['/imei-check']"
        >
          <span class="center">
            <i class="fa fa-compass"></i>
            {{ contentData?.foundMyLostOrStolenDevice }}
          </span>
        </a>
      </div>
    </ng-container>

    <ng-container *ngIf="lineDetails?.lineStatus === lineLandingConstants.SUSPENDED">
      <div
        class="button-box small"
        [ngClass]="
          ((deviceDetailsLineInformation?.imei && deviceDetailsLineInformation?.isImeiValid) ||
            (!isWebChannel &&
              deviceDetailsLineInformation?.imei &&
              !deviceDetailsLineInformation?.isImeiValid)) &&
          lineDetails?.lineSubStatus === lineLandingConstants.LOST_STOLEN
            ? 'col-4'
            : 'col-6'
        "
      >
        <a
          href="javascript:void(0)"
          id="restore-service"
          [ngClass]="{
            disabled:
              lineDetails?.lineSubStatus !== lineLandingConstants.LOST_STOLEN &&
              lineDetails?.lineSubStatus !== lineLandingConstants.NS,
          }"
          (click)="openRestoreServiceModal($event)"
        >
          <span class="center">
            <i class="fa fa-compass"></i>
            {{ contentData?.restoreService }}
          </span>
        </a>
      </div>
    </ng-container>

    <ng-container
      *ngIf="
        lineDetails?.lineStatus === lineLandingConstants.SUSPENDED &&
        lineDetails?.lineSubStatus === lineLandingConstants.LOST_STOLEN &&
        deviceDetailsLineInformation?.imei &&
        deviceDetailsLineInformation?.isImeiValid
      "
    >
      <div
        class="button-box small"
        [ngClass]="
          lineDetails?.lineStatus === lineLandingConstants.SUSPENDED &&
          lineDetails?.lineSubStatus === lineLandingConstants.LOST_STOLEN &&
          deviceDetailsLineInformation?.imei &&
          deviceDetailsLineInformation?.isImeiValid
            ? 'col-4'
            : 'col-6'
        "
      >
        <a
          [class.disabled]="!isPermissionAvailable"
          [routerLink]="['/imei-check']"
          id="report-device-lost"
        >
          <span class="center">
            <i class="fa fa-exclamation-triangle"></i>
            {{ contentData?.foundMyLostOrStolenDevice }}</span
          >
        </a>
      </div>
    </ng-container>
  </div>
</ng-container>

<!-- Ends tertiary buttons section-->
<ng-container *ngIf="lineDetails?.lineStatus === lineLandingConstants.SUSPENDED">
  <tmo-restore-service-modal
    #restoreServiceModal
    [configurableData]="contentData"
    [isImeiValid]="deviceDetailsLineInformation?.isImeiValid"
  >
  </tmo-restore-service-modal>
</ng-container>
